import './libs/magiccursor';
import './partials/_textAnimation';
import './components/header';

window.addEventListener("load", function () {
    const preloaders = document.querySelectorAll(".preloader");

    preloaders.forEach((el) => {
        el.style.transition = "opacity 600ms ease";
        el.style.opacity = "0";

        // Remove from layout after fade
        setTimeout(() => {
            el.style.display = "none";
        }, 600);
    });
});

